import { dom } from "@/utils/dom";

function set(el: HTMLElement, cb: (file: File) => void) {
  const off: Array<() => void> = []
  off.push(
    dom.on(el, 'dragover', (e) => {
      e.preventDefault()
      // if (e.dataTransfer.files.length > 0) {
      //     el.classList.add('file-dragover')
      // }
    }),
    dom.on(el, 'dragleave', (e) => {
      e.preventDefault()
      el.classList.remove('file-dragover')
    }),
    dom.on(el, 'drop', async (e) => {
      e.preventDefault()
      el.classList.remove('file-dragover')
      const files = e.dataTransfer!.files
      for (let i = 0; i < files.length; ++i) {
        const file = files.item(i)!
        cb(file)
      }
    }),
  )
  return () => {
    while (off.length > 0) {
      off.pop()!()
    }
  }
}

export const fileDragAndDrop = {
  set,
}
